import { useOktaAuth } from "@okta/okta-react";
import { NavLink, Outlet } from "react-router-dom";
import { Button } from "./ui";

const NAV = [
  { to: "/", label: "Health", end: true },
  { to: "/reports", label: "Reports" },
  { to: "/recipients", label: "Recipients" },
  { to: "/folders", label: "Watched Folders" },
  { to: "/box-invites", label: "Box Invites" },
  { to: "/history", label: "History" },
];

export function Layout({ email }: { email: string }) {
  const { oktaAuth } = useOktaAuth();
  return (
    <div className="flex min-h-screen bg-neutral-50 text-neutral-900">
      <aside className="flex w-56 flex-col border-r border-neutral-200 bg-white p-4">
        <div className="mb-6 text-lg font-bold">Curse Console</div>
        <nav className="flex flex-1 flex-col gap-1">
          {NAV.map(({ to, label, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `rounded px-3 py-2 text-sm ${isActive ? "bg-black text-white" : "hover:bg-neutral-100"}`
              }
            >
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="mt-4 break-all text-xs text-neutral-500">{email}</div>
        <Button
          variant="secondary"
          className="mt-2"
          onClick={() => oktaAuth.signOut()}
        >
          Sign out
        </Button>
      </aside>
      <main className="flex-1 overflow-auto p-8">
        <Outlet />
      </main>
    </div>
  );
}
